import AccountRepository from '@/shared/http/repositories/access/account'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'analyst/analysts'
const GET_ANALYST_BY_ID = 'getAnalystById'
const GET_ALL_ANLYSTS = 'getAllAnalysts'

export const actionTypes = {
  GET_ANALYST_BY_ID,
  GET_ALL_ANLYSTS
}

export const actions = {
  [GET_ANALYST_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_ANALYST, payload)
  },

  async [GET_ALL_ANLYSTS] ({ commit }, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      AccountRepository.GetAllAnalist()
        .then((res) => {
          commit(mutation.SET_ANALYSTS, res.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/analyst/actions.js